<template>
  <v-container fill-height pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <!-- <span class="hidden-sm-and-up">Welcome, {{ username }}</span> -->
          <v-btn
            v-if="show_update"
            @click="fetchAll"
            :loading="loading"
            color="secondary"
            class="ml-0"
          >All Merchants</v-btn>
          <v-btn v-else 
            color="primary"
            @click="fetchUpdated"
            :loading="loading"
            class="ml-0"
          >Updated Merchant Information</v-btn>
          <v-spacer></v-spacer>
          <div class="align-center d-flex">
            <span>{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
          </div>
        </v-flex>

        <template v-if="show_update">
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">MERCHANT LIST</h3>
                  <h4 class="font-weight-light">{{ updateRequests }} Requests</h4>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              :pagination.sync="pagination"
            >
              <template slot="items" slot-scope="props">
                <tr class="pointer" @click="toroute('update',props.item)">
                  <td>
                    <h3
                      class="font-weight-regular"
                      v-text="props.item.merchant_name || props.item.name"
                    ></h3>
                    <h4 class="font-weight-light" v-text="props.item.address"></h4>
                  </td>
                  <td class="text-xs-center">{{ states[props.item.state] }}</td>
                  <td
                    class="text-xs-center"
                    v-text="props.item.marshal_name || props.item.updated_by_name"
                  ></td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ search }}" merchant has no results.</v-alert>
            </v-data-table>
          </v-card>

          <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :length="pages"></v-pagination>
          </div>
        </template>

        <template v-else>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">ALL MERCHANTS</h3>
                </div>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchApiInput"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-layout>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="merchantLocations"
              :pagination.sync="pagination"
              :total-items="count"
              :loading="loading"
            >
              <template slot="items" slot-scope="props">
                <tr class="pointer" @click="toroute('all',props.item)">
                  <td>
                    <h3
                      class="font-weight-regular"
                      v-text="props.item.merchant_name || props.item.name"
                    ></h3>
                    <h4 class="font-weight-light" v-text="props.item.address"></h4>
                  </td>
                  <td class="text-xs-center">{{ states[props.item.state] }}</td>
                  <td
                    class="text-xs-center"
                    v-text="props.item.marshal_name || props.item.updated_by_name"
                  ></td>
                </tr>
              </template>
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >Your search for "{{ searchApiInput }}" merchant has no results.</v-alert>
            </v-data-table>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
import AppLayout from "../../layouts/app"
import utils from "@/common/utils"
import { debounce } from "lodash"
import {
  FETCH_MERCHANTS,
  FETCH_MERCHANT_LOCATIONS
} from "@/store/actions/merchant"
import { mapState, mapGetters, mapActions } from "vuex"
import { FETCH_MERCHANT_LOCATION } from '../../store/actions/merchant'

export default {
  name: "CCMerchantList",
  data() {
    return {
      getDate: new Date(),
      search: "",
      searchApiInput: "",
      pagination: {
        rowsPerPage: 25
      },
      headers: [
        {
          text: "Merchants",
          align: "left",
          value: "name"
        },
        { text: "State", value: "state" },
        { text: "RM", value: "rm" }
      ],
      loading: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ],
      show_update: true
    }
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
      }
    },
    searchApiInput: function(newQuery, oldQuery) {
      this.loading = true
      this.debouncedSearchApi()
    }
  },
  computed: {
    ...mapState({
      merchantLocations: state => state.merchant.merchantLocations,
      count: state => state.merchant.merchantLocationsCount,
      merchants: state => state.merchant.merchants,
    }),
    username() {
      return this.$store.getters.getProfile.first_name
    },
    items() {
      return [...this.merchants, ...this.merchantLocations]
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      )
    },
    states() {
      return utils.choiceToDict(utils.STATE_CHOICES)
    },
    updateRequests() {
      return this.items.length
    },
    
  },
  methods: {
    toroute(origin, location) {
      if (origin == "update") {
        // merchant
        if (location.name) {
          this.$router.push(`/cc/merchant-update/${location.id}`)
        } else {
          this.$router.push(`/cc/location-update/${location.id}`)
        }
      } else {
        if (location.name) {
          this.$router.push(`/cc/merchants/${location.id}`)
        } else {
          this.$router.push(`/cc/merchants/${location.merchant}/locations/${location.id} `)
        }
      }
    },
    searchApi() {
      this.$store
        .dispatch(FETCH_MERCHANT_LOCATIONS, {
          search: this.searchApiInput,
          page: 1,
          page_size: this.pagination.rowsPerPage
        })
        .then(() => {
          this.loading = false
        })
    },
    getDataFromApi() {
      this.loading = true
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      // Fetch data with page
      this.$store
        .dispatch(FETCH_MERCHANT_LOCATIONS, {
          page: page,
          page_size:  rowsPerPage,
          search: this.search,
          updates: this.show_update ? 'yes' : null
        })
        .then(() => {
          this.loading = false
        })
    },
    fetchAll() {
      this.show_update=false
    },
    fetchUpdated() {
      this.$store.dispatch(FETCH_MERCHANTS, {updates:'yes'})
      this.show_update=true
    }
  },
  created() {
    this.$emit("update:layout", AppLayout)
    this.debouncedSearchApi = debounce(this.searchApi, 1000)
  },
  mounted() {
    this.$store.dispatch(FETCH_MERCHANTS, {updates: 'yes'})
  }
}
</script>

<style scoped>
.merchant-header {
  background: rgba(0, 0, 0, 0.1)
}
</style>

